import { render, staticRenderFns } from "./swiperBox.vue?vue&type=template&id=7235e737&scoped=true&lang=pug&"
import script from "./swiperBox.vue?vue&type=script&lang=js&"
export * from "./swiperBox.vue?vue&type=script&lang=js&"
import style0 from "./swiperBox.vue?vue&type=style&index=0&id=7235e737&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7235e737",
  null
  
)

export default component.exports